import React from 'react';
import { Link } from 'react-router-dom';

const Navigation = ({ user, onLogout }) => {
    if (!user) return null;

    const role = user.role;

    // Определяем видимость пунктов меню по ролям
    const canSeeAccounts = true; // все роли видят лицевые счета
    const canSeeOrders = role === 'admin' || role === 'lawyer' || role === 'accountant' || role === 'user';
    const canSeeStatements = role === 'admin' || role === 'accountant';
    const canSeeDetails = role === 'admin' || role === 'lawyer' || role === 'accountant' || role === 'user';
    const canSeeCorrection = role === 'admin' || role === 'lawyer' || role === 'accountant';
    const canSeeAdmin = role === 'admin';

    return (
        <nav className="navigation">
            {canSeeAccounts && <Link to="/">Лицевые счета</Link>}
            {canSeeOrders && <Link to="/lawyer">Приказы</Link>}
            {canSeeStatements && <Link to="/accountant">Выписки</Link>}
            {canSeeDetails && <Link to="/details">Детализация</Link>}
            {canSeeCorrection && <Link to="/correction">Корректировка</Link>}
            {canSeeAdmin && <Link to="/admin">Админка</Link>}
            <Link to="/changelog">Журнал изменений</Link>
            <button onClick={onLogout} className="logout-btn">Выйти</button>
            <span className="user-info">Вы вошли как: {user.username} ({user.role})</span>
        </nav>
    );
};

export default Navigation;
